import React from 'react';
import './styles.css';

const Card = ({children, size}: {children: React.ReactNode, size?: 'small' | 'medium' | 'large'}) => {

    return (
        <div className={`card ${size}`}>
            {children}
        </div>
    );
};

export default Card;